<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const { t } = useI18n()
const localePath = useLocalePath()

const message = computed(() => String(props.error?.message || ''))
const is404 = computed(() => props.error?.statusCode === 404 || message.value?.includes('404'))
const isDev = import.meta.dev

const handleError = () => clearError({ redirect: localePath('/') })
</script>

<template>
  <NuxtLayout>
    <div class="mx-auto max-w-3xl px-4 pb-16 pt-12 lg:max-w-[88rem] md:max-w-4xl lg:px-8 sm:px-6 sm:pb-24 sm:pt-16">
      <div class="h-screen flex flex-col items-center gap4 text-center">
        <h1 class="m-0 text-3xl font-normal">
          {{ is404 ? t('error.404') : t('error.500') }}
        </h1>

        <div class="text-xl op50">
          {{ t('error.subtext') }}
        </div>

        <div
          v-if="isDev"
          class="rounded-3xl bg-slate-8 px8 py4"
        >
          <div class="text-left text-blue-300">
            {
          </div>
          <div v-for="(value, key, index) in error" :key="index" class="pl4 text-left font-mono">
            <span class="text-white">
              "{{ key }}"
            </span>

            <span class="text-blue-300">
              :
            </span>

            <span class="text-green-300">
              "{{ value }}"
            </span>

            <span v-if="error && index < Object.keys(error).length - 1" class="text-blue-300">
              ,
            </span>
          </div>
          <div class="text-left text-blue-300">
            }
          </div>
        </div>

        <UiButton
          id="go-back"
          variant="destructive"
          class="rounded-full"
          @click="handleError"
        >
          {{ t('general.back') }}
        </UiButton>
      </div>
    </div>
  </NuxtLayout>
</template>
